import React from 'react';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import notification from 'antd/lib/notification';
import Upload from 'antd/lib/upload';
import type { UploadFile } from 'antd/lib/upload/interface';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';

import { getCore } from 'cvat-core-wrapper';
import { t } from 'utils/i18n';

// appends the chosen files to a task's or a reference's data; the page reloads so the new frames show
export function openAddImagesModal(dataPath: string, noun = 'images'): void {
    let fileList: UploadFile[] = [];
    Modal.confirm({
        title: t(`Add ${noun}`),
        icon: null,
        content: (
            <Upload
                multiple
                beforeUpload={() => false}
                onChange={({ fileList: next }) => { fileList = next; }}
                itemRender={(_node, file, _list, actions) => (
                    <div>
                        {file.name}
                        <DeleteOutlined onClick={actions.remove} style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </div>
                )}
            >
                <Button icon={<UploadOutlined />}>{t('Select files')}</Button>
            </Upload>
        ),
        className: 'cvat-modal-confirm-remove-annotation',
        okText: t('Add'),
        onOk: async () => {
            const formData = new FormData();
            fileList.forEach((file, index) => {
                if (file.originFileObj instanceof File) formData.append(`client_files[${index}]`, file.originFileObj);
            });
            const core = getCore();
            try {
                await core.server.request(`${core.config.backendAPI}${dataPath}`, { method: 'PATCH', data: formData });
                window.location.reload();
            } catch (error: unknown) {
                notification.error({
                    message: t(`Could not add ${noun}`),
                    description: error instanceof Error ? error.message : String(error),
                });
            }
        },
    });
}
